import { useState } from 'react';

import { Typography, Box } from '@mui/material';

import { ReferralRewardTabsEnum } from './constants';
import { ReferralRewardSettingsPageTabs } from './ReferralRewardSettingsPageTabs';
import { ReferralSystemSettings } from './ReferralSystemSettings';
import { ReferralValidationSettings } from './ReferralValidationSettings';

import styles from './ReferralRewardSettingsPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';

const { settingsHeader } = styles;

export const ReferralRewardSettingsPage = () => {
  const [currentTab, setCurrentTab] = useState<ReferralRewardTabsEnum>(ReferralRewardTabsEnum.REFERRAL_SYSTEM_SETTINGS);

  const setTab = (value: ReferralRewardTabsEnum) => {
    setCurrentTab(value);
  };

  const renderContentByCurrentTab = () => {
    switch (currentTab) {
      case ReferralRewardTabsEnum.REFERRAL_SYSTEM_SETTINGS: {
        return <ReferralSystemSettings />;
      }
      case ReferralRewardTabsEnum.REFERRAL_VALIDATION_SETTINGS: {
        return <ReferralValidationSettings />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <PageLayout>
      <Typography margin="10px" fontSize="24px" fontWeight={600}>
        Referral Reward Settings
      </Typography>
      <Box className={settingsHeader}>
        <ReferralRewardSettingsPageTabs setTab={setTab} currentTab={currentTab} />
      </Box>
      {renderContentByCurrentTab()}
    </PageLayout>
  );
};
